import {
  NavLink as NavLinkMantine,
  useMantineTheme,
  NavLinkProps,
} from "@mantine/core";
import { NavLink as Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { client_selected } from "../../client";
import { ReactComponent as IconPrediX } from "../../assets/Icons/IconPrediX.svg";

interface IProps extends NavLinkProps {
  to: string;
  target?: string;
  onClick?: any;
  label: string;
}

const NavLinkMatrix = ({ onClick, to, target, label, ...props }: IProps) => {
  const theme = useMantineTheme();
  const location = useLocation();
  const { t } = useTranslation();
  const labelTranslated = t(label);
  const isGenial = client_selected.name === "Genial";
  const labelWithIcon =
    isGenial && labelTranslated === "PrediX" ? (
      <>
        {<IconPrediX width={20} height={25} style={{ marginRight: 5 }} />}
        {labelTranslated}
      </>
    ) : (
      labelTranslated
    );

  return (
    <NavLinkMantine
      active={location.pathname.includes(to)}
      {...props}
      label={labelWithIcon}
      onClick={onClick}
      component={Link}
      to={to}
      target={target}
      styles={{
        root: {
          width: "max-content",
          height: "22px",
          padding: "0",
          margin: "0",
          display: "inline-block",
          fontFamily: "Barlow",
          fontWeight: 400,
          whiteSpace: "nowrap",
          backgroundColor: "unset",
          color: theme.colors.basic[0],
          transition: "0.5s",
          borderBottom: "2px solid transparent",
          cursor: "pointer",
          span: {
            fontSize: "18px",
            lineHeight: "28px",
            fontFamily: "Barlow",
            whiteSpace: "pre-wrap",
          },
          ":after": {
            display: "block",
            content: "''",
            borderBottom: "2.5px solid",
            borderColor: theme.colors.primary[2],
            transform: "scaleX(0)",
            transition: "transform 500ms ease-in-out",
            transformOrigin: "0% 10%",
          },
          ":hover": {
            fontWeight: 700,

            "&:after": {
              transform: "scaleX(1)",
            },
          },
          "&[data-active]": {
            backgroundColor: "unset",
            color: theme.colors.basic[0],
            transition: "0.5s",
            fontWeight: 700,

            ":after": {
              display: "block",
              content: "''",
              borderBottom: "2.5px solid",
              borderColor: theme.colors.primary[2],
              transform: "scaleX(1)",
              transition: "transform 500ms ease-in-out",
              transformOrigin: "0% 10%",
            },

            ":hover": {
              backgroundColor: "unset",
              color: theme.colors.basic[0],
              opacity: 0.95,
              fontWeight: 700,
            },
          },
        },
      }}
    />
  );
};

export default NavLinkMatrix;
